import React from 'react';
import { Form } from 'antd';
import type { FormItemProps as AntFormItemProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndFormItemProps extends AntFormItemProps, BaseComponentProps {}

export const AndFormItem: React.FC<AndFormItemProps> = ({
  id, sessionId, develop, children, ...restProps
}) => {
  return <Form.Item {...restProps}>{children}</Form.Item>;
};

export default AndFormItem;
